import React from "react";
import { Box, Container, Stack, Typography, Link } from "@mui/joy";
import { Link as RouterLink } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderTop: "1px solid #e0e0e0",
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 2, md: 4 }}
          justifyContent="space-between"
          alignItems={{ xs: "center", md: "flex-start" }}
          textAlign={{ xs: "center", md: "left" }}
        >
          <Box>
            <Typography
              level="body-sm"
              sx={{ color: "#7B7F85", mb: 1 }}
            >
              © 2025 Geek. All rights reserved.
            </Typography>
            <Typography
              level="body-sm"
              sx={{ color: "#7B7F85" }}
            >
              Connecting hospitality professionals with great opportunities.
            </Typography>
          </Box>
          
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 1, md: 3 }}
            sx={{ 
              color: "#7B7F85",
              alignItems: "center",
            }}
          >
            <Link
              component={RouterLink}
              to="/privacy"
              level="body-sm"
              sx={{
                color: "#7B7F85",
                textDecoration: "none",
                "&:hover": {
                  color: "#2E2D7E",
                  textDecoration: "underline",
                },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              level="body-sm"
              sx={{
                color: "#7B7F85",
                textDecoration: "none",
                "&:hover": {
                  color: "#2E2D7E",
                  textDecoration: "underline",
                },
              }}
            >
              Terms of Service
            </Link>
            <Link
              component={RouterLink}
              to="/contact"
              level="body-sm"
              sx={{
                color: "#7B7F85",
                textDecoration: "none",
                "&:hover": {
                  color: "#2E2D7E",
                  textDecoration: "underline",
                },
              }}
            >
              Contact Us
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer; 